import React from "react";

const EditIcon = ({ className }) => {
  return (
    <svg
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.3953 11.989C11.2141 12.1701 10.9901 12.3085 10.7474 12.3894L8.40337 13.1707C8.2342 13.2271 8.05777 13.2558 7.87928 13.2558C7.43651 13.2558 7.02027 13.0834 6.70723 12.7703C6.26042 12.3234 6.10705 11.6735 6.30686 11.0741L7.08823 8.73018C7.16907 8.48742 7.30756 8.26333 7.4886 8.0823L12.5514 3.01953H2.6459C1.52888 3.01953 0.620117 3.9283 0.620117 5.04532V16.8317C0.620117 17.9487 1.52888 18.8575 2.6459 18.8575H14.4323C15.5493 18.8575 16.4581 17.9487 16.4581 16.8317V6.9262L11.3953 11.989Z"
        fill="currentColor"
      />
      <path
        d="M8.26935 8.86467C8.20869 8.92533 8.16302 8.99925 8.13591 9.08061L7.35455 11.4246C7.28836 11.6231 7.34003 11.842 7.48799 11.99C7.63598 12.138 7.85484 12.1896 8.05337 12.1234L10.3974 11.3421C10.4788 11.315 10.5527 11.2693 10.6133 11.2086L17.5151 4.30687L15.1712 1.96289L8.26935 8.86467Z"
        fill="currentColor"
      />
      <path
        d="M18.1669 0.269696C17.8073 -0.0898988 17.2243 -0.0898988 16.8647 0.269696L15.9531 1.18126L18.2971 3.52528L19.2087 2.61371C19.5683 2.25412 19.5683 1.6711 19.2087 1.3115L18.1669 0.269696Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default EditIcon;
